import LeftPanelPageTabsContainer from 'components/LeftPanelPageTabs/LeftPanelPageTabsContainer';

export default LeftPanelPageTabsContainer;